import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {EXAMPLE_AREA_M2} from "../constants/example_area_m2";
import {getHeaderPictures} from "../helpers/get_header_pictures";
import {usePricesHeaderData} from "../utils/use_prices_header_data";

interface Props {
    region: IRegionReportPrice;
}

export const PricesCityHero = (props: Props) => {
    const {region} = props;
    const pictures = getHeaderPictures(region.slug);
    const {dataToRender} = usePricesHeaderData(region.slug);

    const priceM2 = dataToRender ? Math.round(dataToRender.avr_price_m2.price) : null;
    const exampleTotalPrice = priceM2 ? priceM2 * EXAMPLE_AREA_M2 : null;

    return (
        <Container className={containerStyle}>
            <div className={heroStyle}>
                <Picture
                    className={pictureStyle}
                    imageClassName={imageStyle}
                    fit="cover"
                    alt={`${region.short_name} — panorama miasta`}
                    sources={[
                        {minWidthPX: 0, src: pictures.xs, height: 360, width: 448},
                        {minWidthPX: 360, src: pictures.sm, height: 600, width: 448},
                        {minWidthPX: 600, src: pictures.md, height: 588, width: 1366},
                        {minWidthPX: 1366, src: pictures.lg, height: 826, width: 1919}
                    ]}
                />

                <div className={overlayStyle} />

                <div className={contentStyle}>
                    <SeoMainHeadline as="h1" variant="headline_0" fontFamily="secondary" color="var(--colors-white)" className={headlineStyle} mb={3}>
                        Ceny mieszkań {region.short_name}
                    </SeoMainHeadline>

                    {priceM2 && (
                        <div className={priceRowStyle}>
                            <Text variant="headline_0" as="p" color="var(--colors-white)">
                                {priceFormat(priceM2)}
                            </Text>
                            <Text variant="body_copy_0" as="p" color="var(--colors-white)">
                                za m²
                            </Text>
                        </div>
                    )}

                    {exampleTotalPrice && (
                        <Text variant="body_copy_0" color="var(--colors-white)">
                            Szacunkowy koszt mieszkania o powierzchni {EXAMPLE_AREA_M2} m² to dziś około {priceFormat(exampleTotalPrice)}.
                        </Text>
                    )}
                </div>
            </div>
        </Container>
    );
};

const containerStyle = css({
    my: 3,

    md: {
        my: 3.5
    }
});

const heroStyle = css({
    position: "relative",
    overflow: "hidden",
    minHeight: "348px",
    borderRadius: 3,

    md: {
        minHeight: "400px"
    }
});

const pictureStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%"
});

const imageStyle = css({
    width: "100%",
    height: "100%",
    objectFit: "cover"
});

const overlayStyle = css({
    position: "absolute",
    inset: 0,
    background: "linear-gradient(180deg, rgba(23, 23, 28, 0.94902) 0%, rgba(23, 23, 28, 0.819608) 60%, rgba(23, 23, 28, 0.501961) 100%)"
});

const contentStyle = css({
    position: "relative",
    zIndex: 1,
    py: 2,
    px: 2,
    display: "flex",
    flexDirection: "column",
    minHeight: "inherit",
    alignItems: "flex-start",
    justifyContent: "center",

    md: {
        py: 5.5,
        px: 7
    }
});

const priceRowStyle = css({
    display: "flex",
    alignItems: "baseline",
    gap: 1
});

// headline_0 is 600 in the design system - the Figma spec for this hero calls for Regular (400)
const headlineStyle = css({
    fontWeight: "400"
});
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {EXAMPLE_AREA_M2} from "../constants/example_area_m2";
import {getHeaderPictures} from "../helpers/get_header_pictures";
import {usePricesHeaderData} from "../utils/use_prices_header_data";

interface Props {
    region: IRegionReportPrice;
}

export const PricesCityHero = (props: Props) => {
    const {region} = props;
    const pictures = getHeaderPictures(region.slug);
    const {dataToRender} = usePricesHeaderData(region.slug);

    const priceM2 = dataToRender ? Math.round(dataToRender.avr_price_m2.price) : null;
    const exampleTotalPrice = priceM2 ? priceM2 * EXAMPLE_AREA_M2 : null;

    return (
        <Container className={containerStyle}>
            <div className={heroStyle}>
                <Picture
                    className={pictureStyle}
                    imageClassName={imageStyle}
                    fit="cover"
                    alt={`${region.short_name} — panorama miasta`}
                    sources={[
                        {minWidthPX: 0, src: pictures.xs, height: 360, width: 448},
                        {minWidthPX: 360, src: pictures.sm, height: 600, width: 448},
                        {minWidthPX: 600, src: pictures.md, height: 588, width: 1366},
                        {minWidthPX: 1366, src: pictures.lg, height: 826, width: 1919}
                    ]}
                />

                <div className={overlayStyle} />

                <div className={contentStyle}>
                    <SeoMainHeadline as="h1" variant="headline_0" fontFamily="secondary" color="var(--colors-white)" className={headlineStyle} mb={3}>
                        Ceny mieszkań {region.short_name}
                    </SeoMainHeadline>

                    {priceM2 && (
                        <div className={priceRowStyle}>
                            <Text variant="headline_0" as="p" color="var(--colors-white)">
                                {priceFormat(priceM2)}
                            </Text>
                            <Text variant="body_copy_0" as="p" color="var(--colors-white)">
                                za m²
                            </Text>
                        </div>
                    )}

                    {exampleTotalPrice && (
                        <Text variant="body_copy_0" color="var(--colors-white)">
                            Szacunkowy koszt mieszkania o powierzchni {EXAMPLE_AREA_M2} m² to dziś około {priceFormat(exampleTotalPrice)}.
                        </Text>
                    )}
                </div>
            </div>
        </Container>
    );
};

const containerStyle = css({
    my: 3,

    md: {
        my: 3.5
    }
});

const heroStyle = css({
    position: "relative",
    overflow: "hidden",
    minHeight: "348px",
    borderRadius: 3,

    md: {
        minHeight: "400px"
    }
});

const pictureStyle = css({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%"
});

const imageStyle = css({
    width: "100%",
    height: "100%",
    objectFit: "cover"
});

const overlayStyle = css({
    position: "absolute",
    inset: 0,
    background: "linear-gradient(180deg, rgba(23, 23, 28, 0.94902) 0%, rgba(23, 23, 28, 0.819608) 60%, rgba(23, 23, 28, 0.501961) 100%)"
});

const contentStyle = css({
    position: "relative",
    zIndex: 1,
    py: 2,
    px: 2,
    display: "flex",
    flexDirection: "column",
    minHeight: "inherit",
    alignItems: "flex-start",
    justifyContent: "center",

    md: {
        py: 5.5,
        px: 7
    }
});

const priceRowStyle = css({
    display: "flex",
    alignItems: "baseline",
    gap: 1
});

// headline_0 is 600 in the design system - the Figma spec for this hero calls for Regular (400)
const headlineStyle = css({
    fontWeight: "400"
});
